import styled from 'styled-components'

export const StyledPartnerCardContainer = styled.div`
  width: 100%;
  margin: 22px auto 0 auto;

  @media (min-width: 768px) {
    max-width: 1920px;
  }
`
